module.exports = __webpack_public_path__ + "img/img-average-vehicle-rating.2bc65796.svg";